module.exports = __webpack_public_path__ + "static/media/logo_cgt.1eaafcf5.svg";